import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import {
	Nav,
	NavItem,
	NavLink,
	NavbarToggler,
	Collapse,
} from 'reactstrap';

import { messages } from '../../../i18n';

import './LoggedOutNav.scss';

const propTypes = {

	/**
	 * The organization for the current user.
	 */
	myOrganization: PropTypes.shape({

		/**
		 * The organization's catalog type.
		 */
		catalog_type: PropTypes.string.isRequired,

	}).isRequired,

};

const ORGANIZATION_CATALOG_TYPE_MULTI = 'multi';

const LoggedOutNav = (props) => {

	const { myOrganization } = props;

	const intl = useIntl();

	const [isOpen, setIsOpen] = useState(false);

	const toggle = () => setIsOpen(!isOpen);

	const navbarTogglerTitle = isOpen
		? intl.formatMessage(messages.TC_COMPONENTS_GENERAL_DROPDOWN_TOGGLE_CLOSE)
		: intl.formatMessage(messages.TC_COMPONENTS_GENERAL_DROPDOWN_TOGGLE_OPEN);

	return (
		<>
			<form className="tc-universal-navbar-logged-out-form d-none d-sm-flex ms-sm-auto">
				<a
					className="btn btn-primary"
					href="/login"
					role="button">
					<span>
						<FormattedMessage {...messages.TC_COMPONENTS_UNIVERSAL_NAVBAR_ACTION_TEXT_LOGIN} />
					</span>
				</a>
				{myOrganization.catalog_type === ORGANIZATION_CATALOG_TYPE_MULTI &&
					<a
						className="btn btn-success ms-3"
						href="/register"
						role="button">
						<span>
							<FormattedMessage {...messages.TC_COMPONENTS_UNIVERSAL_NAVBAR_ACTION_TEXT_REGISTER} />
						</span>
					</a>
				}
			</form>
			<NavbarToggler
				className="tc-icon-button btn d-block d-sm-none"
				tag="button"
				aria-label={navbarTogglerTitle}
				title={navbarTogglerTitle}
				style={{ width: '45px', height: '45px' }}
				onClick={toggle}>
				<i className="far fa-bars fa-lg" />
			</NavbarToggler>
			<Collapse
				isOpen={isOpen}
				navbar>
				<Nav
					className="align-items-center"
					navbar>
					<NavItem>
						<NavLink href="/login">
							<span>
								<FormattedMessage {...messages.TC_COMPONENTS_UNIVERSAL_NAVBAR_ACTION_TEXT_LOGIN} />
							</span>
						</NavLink>
					</NavItem>
					{myOrganization.catalog_type === ORGANIZATION_CATALOG_TYPE_MULTI &&
						<NavItem>
							<NavLink href="/register">
								<span>
									<FormattedMessage {...messages.TC_COMPONENTS_UNIVERSAL_NAVBAR_ACTION_TEXT_REGISTER} />
								</span>
							</NavLink>
						</NavItem>
					}
				</Nav>
			</Collapse>
		</>
	);

};

LoggedOutNav.propTypes = propTypes;

export default LoggedOutNav;
